module.exports = __webpack_public_path__ + "static/media/DSC04786.7239ea80.JPG";